module.exports = __webpack_public_path__ + "img/activity-1-ko.ffbc3534.png";